module.exports = __webpack_public_path__ + "img/Scientific_Single_Frame0001.ec8f19f6.jpg";